import * as React from 'react'
import styled from 'styled-components'
import * as Prices from 'theme/atoms/Price'
import Price from 'theme/atoms/Price'
import { CartItem } from 'hooks/account/types'
import theme from 'theme'

type Props = {
  item: CartItem
}

export default function PriceInfo(props: Props) {
  const hasReduction = Prices.PriceHasStrikePrice(
    props.item,
    props.item.quantity
  )

  return (
    <Wrapper className="PriceInfo" $strikePrice={hasReduction}>
      <div className="top">
        <div className="main-price-container">
          {hasReduction && (
            <div className="strike-price" data-cy-state="cartitem-is-reduced">
              <Prices.PriceStrike
                prices={props.item.prices}
                logic="pack"
                amount={props.item.quantity}
                scalePrice={props.item.priceRules}
              />
            </div>
          )}
          <div className="pack-price-sum">
            <div className="price">
              <Price
                prices={props.item.prices}
                logic="pack"
                amount={props.item.quantity}
                scalePrice={props.item.priceRules}
              />
            </div>
            {(props.item.prices.ecoTaxNet || props.item.prices.ecoTaxGross) && (
              <div
                className="eco-price-desc"
                data-cy-state={'cartitem-has-ecotax'}
              >
                <Prices.EcoTax
                  prices={props.item.prices}
                  amount={props.item.quantity}
                />
              </div>
            )}
          </div>
        </div>
        {props.item.quantity > 1 && (
          <div className="price-per-pack" data-cy-state="show-pack-price">
            <Price prices={props.item.prices} logic="pack" amount={1} /> /{' '}
            {props.item.unit.packUnit}
          </div>
        )}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $strikePrice: boolean }>`
  display: flex;
  flex-direction: column;

  .eco-price-desc {
    ${theme.ty('r-xs', '400', 'r-s')};
    color: ${theme.colors.shade.b2};
  }
  .price {
    @media (min-width: ${theme.ms.SM}px) {
      text-align: right;
    }
  }
  > .top {
    display: flex;
    gap: ${theme.spacing('xxs')};
    justify-content: flex-end;
    flex-direction: column;

    @media (min-width: ${theme.ms.SM}px) {
      align-items: end;
    }

    > .main-price-container {
      display: flex;
      flex-direction: row;
      gap: ${theme.spacing('xxs')};

      > .strike-price {
        ${theme.ty('r-s', null, 'r-base')}
      }

      > .pack-price-sum {
        ${theme.ty('r-s', 'bold', 'r-base')}
        color: ${(p) =>
          p.$strikePrice ? theme.colors.accent.red : theme.colors.b0};
      }
    }

    > .price-per-pack {
      ${theme.ty('r-xs', null, 'r-s')}
    }
  }

  > .piece-price,
  .pack-price {
    ${theme.ty('r-xs', null, 'r-s')}
    text-align: right;
    color: ${theme.colors.shade.b3};
  }
`
